import React from "react";
import ImageGallery from "react-image-gallery";
import 'react-image-gallery/styles/css/image-gallery.css';

function Meme() {
    const importAllImages = (requireContext) => {
      return requireContext.keys().map(requireContext);
    };

    // Import all images from the "images" folder
    const images = importAllImages(require.context('../../assets/images/meme', false, /\.jpg$/));

    const galleryImages = images.map((image) => ({
      original: image,
      thumbnail: image, // Optional, if you want thumbnails
    }));

    const customRenderItem = (item) => (
      <div style={{ height: '500px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img
          src={item.original}
          alt=""
          style={{
            height: '100%', // Fixed height (300px from parent container)
            width: 'auto', // Auto width to maintain aspect ratio
            objectFit: 'contain', // Ensures proper scaling
          }}
        />
      </div>
    );

    return (
        <div>
          <ImageGallery items={galleryImages} renderItem={customRenderItem} />
        </div>
      );
}

export default Meme;
